import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { useUserStore } from 'src/_store/user.store'
import { IOrder, ISupplierOrder } from 'src/_models/order.model'
import { useTranslation } from 'react-i18next'
import OrderDetailTables from 'src/pages/fuel-trading/order-detail-tables'
import { useSearchParams } from 'react-router-dom'

const FuelTradingOrdersDisputedPage = () => {
  const [orders, setOrders] = useState<IOrder[]>([])
  const [searchParams, _] = useSearchParams()

  const params = searchParams.toString()

  const disputedOrdersQuery = useQuery({
    queryKey: ['orders', 'orders/disputed', params],
    queryFn: () => {
      const token = localStorage.getItem('token')
      return axios.get<ISupplierOrder[]>(`/api/orders/disputed?${params}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    },
  })

  useEffect(() => {
    if (disputedOrdersQuery.data) {
      setOrders(disputedOrdersQuery.data.data)
    }
  }, [disputedOrdersQuery.data])

  return (
    <>
      <section className="w-full">
        <OrderDetailTables heading="Disputed Orders" orders={orders} />
      </section>
    </>
  )
}

export default FuelTradingOrdersDisputedPage
